import React from 'react'
import { connect } from "react-redux"
import { $moment } from 'funcs'
import moment from 'moment'
import { httpClient } from 'funcs'
import { loadSelf } from '../../../methods/loadSelf'
import SubscribeChannelPopup from '../../../components/SubscribeChannelPopup'

let NavBalance: any = function (props: any & { $commitToStore?: (data: any) => void }) {
    const userSession = props.$store.userSession;
    const balance = props.$store.balance;
    const tariff = userSession?.tariff;
    const tariffType = tariff?.type ?? 'package'
    const [showGetTestBalance, setShowGetTestBalance] = React.useState(false)

    const handleSuccess = async () => {
        // Обновляем баланс локально без перезагрузки данных пользователя
        // Баланс будет обновлен из ответа API в SubscribeChannelPopup
    }

    const shouldShowGetBalanceButton = () => {
        return userSession?.received_test_balance === false
    }

    const GetBalanceButton = () => (
        <button
            className="new withTitle small"
            onClick={() => setShowGetTestBalance(true)}
            style={{
                background: 'transparent',
                border: '1px solid #75809E',
                color: '#75809E',
                fontSize: '11px',
                padding: '2px 6px',
                borderRadius: '10px',
                fontWeight: '500',
                lineHeight: '1.2',
                minHeight: 'auto'
            }}
        >
            получить +5 документов
        </button>
    )

    const getBalanceText = () => {
        if (balance === null || balance === undefined) return null;
        
        // Если есть активная подписка
        if (tariffType == 'subscription' && userSession?.next_subscription_charge_date) {
            const endDate = $moment(userSession?.next_subscription_charge_date).format('D.M.YYYY');
            return `Подписка до ${endDate}`;
        }

        // Если подписка отменена, но еще активна
        if (balance === 0 && userSession?.subscription_active_until) {
            const activeUntil = $moment(userSession.subscription_active_until);
            if (activeUntil.isAfter(moment())) {
                return `Подписка активна до ${activeUntil.format('D.M.YYYY')}`;
            }
        }
        
        // Если есть баланс договоров
        if (balance >= 0) {
            return `Баланс: ${balance}`;
        }
        
        return null;
    };

    const balanceText = getBalanceText();
    
    if (!balanceText) return null;

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{
                color: '#75809E',
                fontSize: '13px',
                fontWeight: 500,
                lineHeight: '16px'
            }}>
                {balanceText}
            </span>
            {shouldShowGetBalanceButton() && <GetBalanceButton />}
            
            {/* Попап для подписки на канал */}
            {showGetTestBalance && (
                <SubscribeChannelPopup 
                    onClose={() => setShowGetTestBalance(false)}
                    onSuccess={handleSuccess}
                    $store={props.$store}
                    $commitToStore={props.$commitToStore}
                />
            )}
        </div>
    );
}

NavBalance = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({ $commitToStore: (data: any) => dispatch({ ...data, type: 'S' }) })
)(NavBalance);

export default NavBalance; 